import type {
  AccessoryCardData,
  DiscountBanner,
  ProductLabel,
  ResolvedCardPrices,
  StockInfo,
} from '../product/index';

import type { ProductImage } from '../effect/schema/openapi/backend';

/**
 * `AccessoryCardData` with its money already resolved to plain numbers.
 *
 * The bundle assembles this item inside a `'use client'` component and joins
 * it to the `ProductAccessoryFields` lines that arrived over the RSC boundary,
 * so both halves of that list carry the same scalar money (rule 11).
 */
export type ProductAccessoryItem = ResolvedCardPrices<AccessoryCardData>;

/** Only the fields `mapProductToAccessoryItem` reads. */
type HasAccessoryProductFields = {
  readonly name: string;
  readonly metaTitle: string | null;
  readonly code: string;
  readonly routerUrl: string;
  readonly shortDescription: string;
  readonly subtitle: string | null;
  readonly price: number;
  readonly priceWithoutTax: number;
  readonly originalPrice: number | null;
  readonly discountBanner: DiscountBanner | null;
  readonly labels: readonly ProductLabel[];
  readonly ageRestriction: 'none' | '18+';
};

export function mapProductToAccessoryItem(
  mainProduct: HasAccessoryProductFields,
  mainProductImage: ProductImage | null,
  stock: StockInfo
): ProductAccessoryItem {
  return {
    name: mainProduct.name,
    metaTitle: mainProduct.metaTitle ?? mainProduct.name,
    slug: '',
    code: mainProduct.code,
    routerUrl: mainProduct.routerUrl,
    imagePath: mainProductImage?.pathAbstract ?? null,
    description: mainProduct.shortDescription,
    subtitle: mainProduct.subtitle,
    price: mainProduct.price,
    priceWithoutTax: mainProduct.priceWithoutTax,
    originalPrice: mainProduct.originalPrice,
    stock: stock,
    discountBanner: mainProduct.discountBanner,
    labels: mainProduct.labels,
    isFavourite: false,
    ageRestriction: mainProduct.ageRestriction,
    category: null,
    label: null,
    quantity: 1,
  };
}
